/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {
  AnalyticsGuardWindow,
  disableAnalyticsOnCompleteWaivers,
} from './app/v2/components/public/complete-waivers/complete-waivers-analytics-guard';

// Before bootstrap, so it runs ahead of Firebase Analytics initializing:
// Complete Waivers and participant signing URLs carry tokens that must not
// reach an automatic page_view.
disableAnalyticsOnCompleteWaivers(window as unknown as AnalyticsGuardWindow, environment.firebase?.measurementId);

if (location.hostname !== "localhost" && location.hostname !== "127.0.0.1"){
  if(window){
    window.console.log=function(){};
  }
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
